import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="28"
      fill="none"
      viewBox="0 0 32 28"
    >
      <path
        fill="#fff"
        d="M12.663 26.212V17.88h6.667v8.333c0 .917.75 1.667 1.667 1.667h5c.916 0 1.666-.75 1.666-1.667V14.546h2.834c.766 0 1.133-.95.55-1.45L17.113.546a1.68 1.68 0 00-2.233 0L.947 13.096c-.567.5-.217 1.45.55 1.45H4.33v11.666c0 .917.75 1.667 1.667 1.667h5c.916 0 1.666-.75 1.666-1.667z"
      ></path>
    </svg>
  );
}

export default Icon;
